module.exports = __webpack_public_path__ + "img/enterprise_banner5_2.7eccb23e.png";